/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word Unscrambler — Make Words from Letters | Toolverse`)
};

const es_wu_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descifrador de Palabras — Forma Palabras con Letras | Toolverse`)
};

const de_wu_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wortentwirrer — Wörter aus Buchstaben bilden | Toolverse`)
};

const nl_wu_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woorden Ontwarren — Maak Woorden van Letters | Toolverse`)
};

const fr_wu_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déchiffreur de Mots — Former des Mots avec des Lettres | Toolverse`)
};

const it_wu_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca Parole — Crea Parole dalle Lettere | Toolverse`)
};

const pt_br2_wu_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desembaralhador de Palavras — Forme Palavras a Partir de Letras | Toolverse`)
};

const pt_wu_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbaralhador de Palavras — Forme Palavras a Partir de Letras | Toolverse`)
};

const ja_wu_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字並べ替えツール — 文字から単語を作る | Toolverse`)
};

const zh_wu_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字母重组工具 — 用字母拼出单词 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_hub_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_hub_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_hub_meta_title", locale)
	if (locale === "en") return en_wu_hub_meta_title(inputs)
	if (locale === "es") return es_wu_hub_meta_title(inputs)
	if (locale === "de") return de_wu_hub_meta_title(inputs)
	if (locale === "nl") return nl_wu_hub_meta_title(inputs)
	if (locale === "fr") return fr_wu_hub_meta_title(inputs)
	if (locale === "it") return it_wu_hub_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_wu_hub_meta_title(inputs)
	if (locale === "pt") return pt_wu_hub_meta_title(inputs)
	if (locale === "ja") return ja_wu_hub_meta_title(inputs)
	return zh_wu_hub_meta_title(inputs)
};